import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AdminTransferTable from "@components/table/zenith/AdminTransferTable";
import AdminTransferModal from "@components/modal/AdminTransferModal";
import { useApprovalTabsContext } from "@components/layout/zenith/ApprovalTabs";
import { useAdministrativeApproval } from "@hooks/query/zenith/useAdministrativeApproval";

const AdminTransferIndex = () => {
  const { t } = useTranslation();
  const { setBreadcrumbs } = useApprovalTabsContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const approvalId = searchParams.get("id") ?? "";
  const { data } = useAdministrativeApproval(approvalId);

  React.useEffect(() => {
    setBreadcrumbs([
      {
        label: t("approval.admin_transfer.title"),
      },
    ]);
  }, [t, setBreadcrumbs]);

  const handleClose = () => {
    searchParams.delete("id");
    setSearchParams();
  };

  return (
    <>
      <AdminTransferTable />

      {approvalId && data ? (
        <AdminTransferModal
          data={data}
          onClose={handleClose}
          actionButtons={
            <button className="btn-default" onClick={handleClose}>
              {t("common.close")}
            </button>
          }
        />
      ) : null}
    </>
  );
};

export default AdminTransferIndex;
